import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;
import styled, { css } from 'styled-components';
import { get } from '../../styles/constant';
const getDynamicBackground = _ref => {
  let {
    active,
    disabled
  } = _ref;
  let background;
  if (active) {
    background = get('colors.primary.blue.300');
  }
  if (disabled) {
    background = get('colors.functional.grey.100');
  }
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    background-color: ", ";\n  "])), background);
};
const getActiveColor = _ref2 => {
  let {
    active,
    disabled
  } = _ref2;
  if (active && disabled) {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      color: ", ";\n    "])), get('colors.functional.grey.800'));
  }
  if (active && !disabled) {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      color: ", ";\n    "])), get('colors.functional.grey.50'));
  }
  return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    color: ", ";\n  "])), get('colors.functional.grey.800'));
};
const getHoverColor = _ref3 => {
  let {
    staticItem,
    active
  } = _ref3;
  const background = staticItem || active ? '' : get('colors.functional.grey.200');
  return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    background-color: ", ";\n  "])), background);
};
const getDynamicPadding = _ref4 => {
  let {
    indented,
    staticItem
  } = _ref4;
  let padding = '8px 12px';
  if (indented) {
    padding = '8px 12px 8px 24px';
  }
  if (staticItem) {
    padding = '12px 12px';
  }
  return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    padding: ", ";\n  "])), padding);
};
const Wrapper = styled.ul(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  border: 1px solid ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  color: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  padding: 0;\n  overflow: ", ";\n  max-height: ", ";\n  display: ", ";\n  &::-webkit-scrollbar {\n    width: ", ";\n    height: ", ";\n  }\n  &::-webkit-scrollbar-thumb {\n    background-color: ", ";\n    border-radius: ", ";\n  }\n"])), get('colors.functional.grey.400'), get('space.4'), get('boxShadows.card.4'), get('colors.functional.grey.800'), get('fontSizes.16'), get('lineHeights.24'), props => props.maxHeight && 'auto', props => props.maxHeight, props => props.$hidden && 'none', get('space.8'), get('space.8'), get('colors.functional.grey.600'), get('space.8'));
const Item = styled.li(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  &&& {\n    display: flex;\n    align-items: center;\n    cursor: ", ";\n    ", "\n    ", "\n  ", "\n\n  &:hover {\n      ", "\n    }\n  }\n"])), props => props.disabled ? 'not-allowed' : 'pointer', props => getDynamicBackground(props), props => getDynamicPadding(props), props => getActiveColor(props), props => getHoverColor(props));
const Graphics = styled.span(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  margin-right: ", ";\n"])), get('space.12'));
const Icon = styled.span(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: flex;\n  margin-right: ", ";\n"])), get('space.13'));
const Content = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: ", ";\n  flex-grow: 2;\n  color: ", ";\n  > p {\n    margin: 0;\n  }\n\n  span {\n    font-size: ", ";\n    line-height: ", ";\n  }\n"])), props => props.markInput ? 'row' : 'column', props => props.disabled && props.active && 'black', get('fontSizes.12'), get('lineHeights.16'));
const Components = {
  Content,
  Graphics,
  Icon,
  Item,
  Wrapper
};
export { Components };